module.exports = __webpack_public_path__ + "img/rank_icon_6.0ddbc700.png";